var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"ab-button",class:{
    [`ab-button--${_vm.size}`]: true,
    [`ab-button--${_vm.textAlignment}`]: _vm.textAlignment !== 'center',
    'ab-button--full-width': _vm.fullWidth === true,
    'loading-spinner': _vm.loading,
  },on:{"click":_vm.onClick}},[_c('span',[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }